// extracted by mini-css-extract-plugin
export var addressFields = "_pi-0";
export var animationContainer = "_pi-1";
export var footer = "_pi-2";
export var lineItems = "_pi-3";
export var modalContent = "_pi-4";
export var orderName = "_pi-5";
export var strong = "_pi-6";
export var warning = "_pi-7";